import { InjectionToken } from '@angular/core';

export type WindowRef = Window;

export const WINDOW = new InjectionToken<WindowRef>('Properly typed native window', {
    providedIn: 'root',
    factory: () => window as WindowRef
});
